import type { DicomPatientProfile } from '../../ComponnentsUI/features/AddPatientForm/types';
import type { PacsStudy } from '../../ComponnentsUI/NewCaseWizard/PacsSyncWizard';

export function getLoadErrorMessage(error: unknown, fallback: string): string {
  if (!error) return fallback;
  const err = error as {
    response?: { data?: { message?: string; detail?: string } };
    message?: string;
  };
  const detail = err.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  return err.response?.data?.message || err.message || fallback;
}

export type PatientFormLocationState = {
  returnTo?: string;
  initialDataFromDicom?: DicomPatientProfile;
  selectedPacsStudy?: PacsStudy;
};
